import { render, staticRenderFns } from "./Apotheken.vue?vue&type=template&id=2b99231a&scoped=true"
import script from "./Apotheken.vue?vue&type=script&lang=js"
export * from "./Apotheken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99231a",
  null
  
)

export default component.exports